'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var anatomy = require('../anatomy.js');
var react = require('@chakra-ui/react');
var dateField = require('./dateField.js');
var _createMultiStyleConf = react.createMultiStyleConfigHelpers(anatomy.timeFieldAnatomy.keys),
  defineMultiStyleConfig = _createMultiStyleConf.defineMultiStyleConfig;
var baseStyle = dateField["default"].baseStyle;
var variants = dateField["default"].variants;
var sizes = dateField["default"].sizes;
var TimeField = defineMultiStyleConfig({
  baseStyle: baseStyle,
  variants: variants,
  sizes: sizes,
  defaultProps: dateField["default"].defaultProps
});
exports["default"] = TimeField;